import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClientType } from "../../types/genericType";

const initialClientState: ClientType = {
  id: 0,
  firstName: "",
  lastName: "",
  taxNumber: "",
  type: "",
  email: "",
  officePhone: "",
  companyName: "",
  homePhone: "",
  mobile: "",
  apartment: "",
  address: "",
  city: "",
  state: "",
  zip: "",
  country: "United States",
  note: "",
  isActive: true,
  name: "",
  fax: ""
};

interface ClientState {
  selectedClient: ClientType;
}

const initialState: ClientState = {
  selectedClient: initialClientState,
};

export const clientSlice = createSlice({
  name: "clientState",
  initialState,
  reducers: {
    setSelectedClient: (state, action: PayloadAction<ClientType>) => {
      state.selectedClient = action.payload;
    },
    resetSelectedClient: (state) => {
      state.selectedClient = initialClientState;
    },
  },
});

export const { setSelectedClient, resetSelectedClient } =
  clientSlice.actions;

export default clientSlice.reducer;
